"use client";

import React, { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { useVariableDisplay } from "../variables/hooks/useVariableDisplay";

interface UnifiedSubjectFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  selectedClient?: any;
  hasError?: boolean;
}

/**
 * Unified subject field that shows the template for editing and provides a preview hint
 * This approach preserves the template while showing what it will look like with variables filled
 */
export function UnifiedSubjectField({
  value,
  onChange,
  placeholder,
  className,
  selectedClient,
  hasError,
}: UnifiedSubjectFieldProps) {
  const previewValue = useVariableDisplay(value, selectedClient);
  const hasVariables = value.includes("{{");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`${className} ${hasError ? "border-red-500 bg-red-50 dark:bg-red-950/40 focus:border-red-500 focus:ring-red-200" : ""}`}
      />

      {/* Show preview hint when there are variables */}
      {hasVariables && value !== previewValue && (
        <div className="text-xs text-muted-foreground mt-1">
          💡 Preview: <span className="font-medium">{previewValue}</span>
        </div>
      )}
    </div>
  );
}
